// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3qkaw","amount":"Amount_amount__2UJ7u","tip":"Amount_tip__3ADWk","tipHeader":"Amount_tipHeader__vgjNI","tipsWrap":"Amount_tipsWrap__-Amc5"};